import { useCallback } from 'react'
import { useForm } from 'react-hook-form'

import useMutateOverrides from '@/hooks/useMutateOverrides'
import useScrollToError from '@/hooks/useScrollToError'

import { Override } from '@/common/types'

import { schema, type FormSchema } from './schema'
import formResolver from './validation'

export const useOverrideForm = (overrides: Override[]) => {
  const form = useForm<FormSchema>({
    defaultValues: schema.parse({
      overrides,
    }),
    resolver: formResolver(schema),
    mode: 'onChange',
    shouldFocusError: true,
  })

  const mutation = useMutateOverrides()
  const [setCanFocus] = useScrollToError(form.formState.errors)

  const submit = useCallback(
    async (data: FormSchema) => {
      try {
        await mutation.mutateAsync(data.overrides)
        form.reset(data)
        shopify.toast.show('Overrides updated', { duration: 2000 })
      } catch {
        setCanFocus(true)
      }
      return true
    },
    [mutation, form, setCanFocus]
  )

  return {
    form,
    submit,
    isPending: mutation.isPending,
  }
}
